import React, { useEffect } from 'react';

export const Timer: React.FC<{ scheduledTime: string }> = ({ scheduledTime }) => {
  const [days, setDays] = React.useState<number>(0);
  const [hours, setHours] = React.useState<number>(0);
  const [minutes, setMinutes] = React.useState<number>(0);
  const [seconds, setSeconds] = React.useState<number>(0);

  const today = Date.now();
  const futTime = new Date(scheduledTime).getTime();

  const startTimer = () => {
    const futureTime = new Date(scheduledTime);
    futureTime.setHours(futureTime.getHours() + 1);
    const interval = setInterval(() => {
      const todayTime = new Date().getTime();

      const difference = futureTime.getTime() - todayTime;
      const days = Math.floor(difference / (24 * 60 * 60 * 1000));
      const hours = Math.floor((difference % (24 * 60 * 60 * 1000)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (60 * 60 * 1000)) / (1000 * 60));
      const seconds = Math.floor((difference % (60 * 1000)) / 1000);

      if (difference < 0) {
        clearInterval(interval);
      } else {
        setDays(days);
        setHours(hours);
        setMinutes(minutes);
        setSeconds(seconds);
      }
    }, 1000);

    return interval;
  };

  useEffect(() => {
    if (futTime > today) {
      const interval = startTimer();

      // Cleanup function to clear the interval
      return () => clearInterval(interval);
    }
  });

  return (
    <>
      <div className="flex shadow-lg shadow-gray-900 text-secondary text-center p-5 rounded-md align-center justify-between w-10/12 md:w-96 bg-gradient-10 bg-gradient-to-r from-[#28272F] to-[#0F1015] ">
        {/* days */}
        <div className="grid gap-2">
          <div>
            <h3 className="text-6xl font-medium bg-clip-text text-transparent bg-gradient-to-br from-[#EEF1F0] to-[#71757E]">
              {days}
            </h3>
          </div>
          <div>
            <p className="font-light text-sm text-[#E4E4E4]">Days</p>
          </div>
        </div>
        <span className="text-6xl font-medium bg-clip-text text-transparent bg-gradient-to-br from-[#EEF1F0] to-[#71757E]">
          &#58;
        </span>
        {/* hours */}
        <div className="grid gap-2">
          <div>
            <h3 className="text-6xl font-medium bg-clip-text text-transparent bg-gradient-to-br from-[#EEF1F0] to-[#71757E]">
              {hours}
            </h3>
          </div>
          <div>
            <p className="font-light text-sm text-[#E4E4E4]">Hours</p>
          </div>
        </div>
        <span className="text-6xl font-medium bg-clip-text text-transparent bg-gradient-to-br from-[#EEF1F0] to-[#71757E]">
          &#58;
        </span>
        {/* minutes */}
        <div className="grid gap-2">
          <div>
            <h3 className="text-6xl font-medium bg-clip-text text-transparent bg-gradient-to-br from-[#EEF1F0] to-[#71757E]">
              {minutes}
            </h3>
          </div>
          <div>
            <p className="font-light text-sm text-[#E4E4E4]">Minutes</p>
          </div>
        </div>
        <span className="text-6xl font-medium bg-clip-text text-transparent bg-gradient-to-br from-[#EEF1F0] to-[#71757E]">
          &#58;
        </span>
        {/* seconds */}
        <div className="grid gap-2">
          <div>
            <h3 className="text-6xl font-medium bg-clip-text text-transparent bg-gradient-to-br from-[#EEF1F0] to-[#71757E]">
              {seconds}
            </h3>
          </div>
          <div>
            <p className="font-light text-sm text-[#E4E4E4]">Seconds</p>
          </div>
        </div>
      </div>
    </>
  );
};
